@if (title) {
<h2 class="mb-1" [attr.data-e2e]="e2e + '-title'">{{ title }}</h2>
}

<div [attr.data-e2e]="e2e + '-items'">
  <ngb-accordion>
    @for (item of items; track item; let index = $index; let last = $last) {
    <ngb-panel [ngClass]="{'mb-1' : !last}">
      <ng-template ngbPanelHeader>
        <button ngbPanelToggle [attr.data-e2e]="e2e + '-items-' + index">
          <div class="accordion-card-title">
            <span class="accordion-title">{{ item.title }}</span>
            <span class="accordion-icon"></span>
          </div>
        </button>
      </ng-template>

      <ng-template ngbPanelContent>
        @for (text of item.description; track text; let index = $index) {
        <p class="standard text-mw" [attr.data-e2e]="e2e + '-items-' + index" [innerHTML]="text"></p>
        } @if (item.link; as link) {
        <a
          [href]="link.url"
          [attr.data-e2e]="e2e + '-items-link'"
          class="o-link-arrow text-mw"
          (click)="clickAccordionLink.emit()"
        >
          {{ link.label }}
        </a>
        }
      </ng-template>
    </ngb-panel>
    }
  </ngb-accordion>
</div>
